<template>
    <div class="wrapper presentation-page">
        <div class="header-1" style="width:100%">
            <div id="particles-js" style="position:absolute;z-index:1;width:100%;height:100%" ></div>
            <!-- <vue-particles 
                    v-if="windowWidth != null && windowWidth > 991"
                    color="#dedede"
                    :particleOpacity="0.5"
                    :particlesNumber="60"
                    shapeType="circle"
                    :particleSize="5"
                    linesColor="#dedede"
                    :linesWidth="2"
                    :lineLinked="true"
                    :lineOpacity="0.2"
                    :linesDistance="250"
                    :moveSpeed="2"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                    style="position:absolute;z-index:1;width:100%;height:100%" >
                </vue-particles>
                <vue-particles 
                    v-if="windowWidth != null && windowWidth < 991"
                    color="#dedede"
                    :particleOpacity="0.5"
                    :particlesNumber="40"
                    shapeType="circle"
                    :particleSize="5"
                    linesColor="#dedede"
                    :linesWidth="2"
                    :lineLinked="true"
                    :lineOpacity="0.2"
                    :linesDistance="250"
                    :moveSpeed="2"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                    style="position:absolute;z-index:1;width:100%;height:100%" >
                </vue-particles> -->
            <div class="page-header header-filter">
                
                <div class="page-header-image" style="background-image: url('img/20161103_100923_2.jpg')"></div>
                
                <div class="content-center" style="pointer-events:none;">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-left">
                                <!-- <h1 class="title">CONTROLS + INNOVATION</h1> -->
                                <h1 class="title">HVAC-R CONTROLS + INNOVATION</h1>
                                <h4 class="description" style="font-weight:500;color:white;">ETC is a full-service commercial &amp; industrial refrigeration &amp; HVAC controls engineering firm focused on providing energy efficiency and monitoring solutions.</h4>
                                <br/>
                                <div class="buttons">
                                    <!-- <a href="#pablo" class="btn btn-icon btn-link btn-neutral btn-lg">
                                        <i class="fab fa-twitter"></i>
                                    </a>
                                    <a href="#pablo" class="btn btn-icon btn-link btn-neutral btn-lg">
                                        <i class="fab fa-facebook-square"></i>
                                    </a>
                                    <a href="#pablo" class="btn btn-icon btn-link btn-neutral btn-lg">
                                        <i class="fab fa-get-pocket"></i>
                                    </a> -->
                                    <a href="#contact" class="btn btn-primary btn-lg mr-3" @click="gConversion()">
                                        Contact us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </div>
        <!--     *********     FEATURES 3      *********      -->
        <div class="features-3" id="readmore">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        
                        <h2 class="title">Facility Control Experts</h2>
                        <h4 class="description">We’re problem solvers. Let us put our minds together to enhance your <b>commercial</b> or <b>industrial</b> facility controls, and watch as everything becomes easier, smarter and more efficient. We can work with your existing <b>refrigeration</b>, <b>HVAC</b>, and <b>lighting</b> systems, or build something entirely new just for you. <a href="#contact" @click="gConversion()">Contact us</a></h4>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <a class="nolink" href="https://gamsplus.com" target="_blank">
                        <div class="info info-hover">
                            <div class="icon icon-primary icon-circle">
                                <!-- <i class="now-ui-icons  ui-1_bell-53"></i> -->
                                <img v-lazy="'img/GLOGO512.png'" alt="GAMS+ Refrigeration Monitoring" class="" style="width: 70%;margin-top:12px;">
                            </div>
                            <h4 class="info-title">Monitoring</h4>
                            <p class="description">Enterprise Refrigeration &amp; HVAC monitoring across any combination of controllers and devices. Feature rich with alerting, compliance, graphical screens and so much more. Intuitive and powerful for everyone on any device.</p>
                            <!-- once location to many. built for every skill and knowledge level, dont need to know much and dont need much traiing. all controller types and other devices, modbus. built by us, who use it every day, to make it an easy, powerful tool for everyone from an on site mechanic to a store manager, to a corportate manager. take control of your own data with data exports. We can work with any current system you have, build a custom ssolution just for you to get your data in any format you require. Cutting edge animated graphics that make it easier to diagnose issues at a glance. Built for mobile, beautiful on desktop, full functionality on every device. dedicated team always improving. -->
                            <!-- show diagram of different networking scenarios. we have several solutions for working with it, secure, encrypted communication.  -->
                            <!-- enteprise section, compliant, reports, all stores and controlelr types together. filter out nuisance larms, maitenance drill downs help forucs on real issues. repeat alarms.  -->
                            <!-- list controller sytems gams works with -->
                            <!-- hvac section -->
                            <!-- works with any modbus device -->
                            <!-- in house develpment team able to develope for any specific need -->
                            <!-- cloud based -->
                            <!-- use case for each: corporate, maintenance department, remodels, controller access ss/e3 to e2 article.  -->
                        </div>
                        </a>
                    </div>
                    <div class="col-md-4">
                        <router-link class="nolink" to="/facility-refrigeration-controls">
                        <div class="info info-hover">
                            <div class="icon icon-success icon-circle">
                                <i class="now-ui-icons ui-2_settings-90"></i>
                            </div>
                            <h4 class="info-title">Controls</h4>
                            <p class="description">Refrigeration, HVAC, and Lighting Control system installation, modernization and support.</p>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link class="nolink" to="/facility-refrigeration-engineering">
                        <div class="info info-hover">
                            <div class="icon icon-info icon-circle">
                                <i class="now-ui-icons education_atom"></i>
                            </div>
                            <h4 class="info-title">Engineering</h4>
                            <p class="description">We can work with you to refresh your existing refrigeration system or build an entirely new refrigeration system designed entirely new, just for you.</p>
                        </div>
                        </router-link>
                    </div>
                    
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 3      *********      -->
        <!--     *********    PROJECTS 3     *********      -->
        <div class="projects-3" data-background-color="black">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <!-- <h6 class="category text-muted">Our work</h6> -->
                        <h2 class="title" style="margin-bottom:30px;">Our Work</h2>
                    </div>
                </div>
                <div class="section-story-overview">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="image-container image-left" v-lazy:background-image="'img/20180816_120938.jpg'">
                                <!-- First image on the left side -->
                                <!-- <p class="blockquote blockquote-primary">ETC is a design/build refrigeration &amp; HVAC controls engineering firm focused on providing energy efficiency and monitoring solutions.  
                                </p> -->
                                <p class="blockquote blockquote-primary" style="width:250px;">
                                    Commercial &amp; Industrial:
                                    <ul>
                                        <li>Supermarkets</li>    
                                        <li>Warehouses</li>  
                                        <li>Pharmaceutical Laboratories</li>  
                                        <li>Food Retail</li>  
                                        <li>Processing Plants</li> 
                                        <li>Refrigerated Storage</li>  
                                        <li>Distribution</li>
                                    </ul> 
                                </p>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <!-- First image on the right side, above the article -->
                            <div class="image-container image-right" v-lazy:background-image="'img/20150625_113008.jpg'">
                            </div>
                            <!-- <h6 class="category text-primary">Design</h6> -->
                            <h4 class="card-title">Engineering Refrigeration Efficiency</h4>
                            <!-- <h6 class="category text-info">Engineering</h6> -->
                            <!-- <p>
                                We engineer the most efficient facility refrigeration rack systems by implementing the use of Variable Frequency Drives on compressors &amp; condenser fan motors, electronic expansion valves, and adaptive defrost techniques. 
                            </p> -->
                            <p>
                                Your product’s integrity is our company's business. Our refrigeration system engineers design highly efficient refrigeration racks and systems that ensure temperature quality throughout your space while driving energy efficiency to increase your return on investment.
                            </p>
                            <router-link class="btn btn-primary " to="/facility-refrigeration-engineering">Engineering with ETC</router-link>
                        </div>
                    </div>
                </div>
                <div class="section-story-overview">
                    <div class="row">
                        <div class="col-md-6">
                            <!-- First image on the left side -->
                            <!-- <div class="image-container image-left" v-lazy:background-image="'img/20161108_113035_2.jpg'"> -->
                            <div class="image-container image-left" v-lazy:background-image="'img/modernize.jpg'">
                                    
                                <p class="blockquote blockquote-primary" style="width:270px;">
                                    We’ve worked with companies around the globe to drive energy efficiency throughout their refrigeration, HVAC and lighting control systems
                                
                                </p>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <!-- First image on the right side, above the article -->
                            <!-- <div class="image-container image-right" v-lazy:background-image="'img/20161101_172939.jpg'"> -->
                            <div class="image-container image-right" v-lazy:background-image="'img/industrial.png'">
                            </div>
                            <!-- <h6 class="category text-primary">E-Decor</h6> -->
                            <h4 class="card-title">Controls Modernization</h4>
                            <!-- <h6 class="category text-success">Facility Controls</h6> -->
                            <!-- <p>
                                We design and install new control systems to modernize your existing hardware with the newest technology, with the ability to view and interrogate your system remotely. 
                            </p> -->
                            <p>
                                For the past 30 years we have specialized in electronic facility controls for pharmaceutical labs, supermarkets, warehouses, processing plants and other commercial &amp; industrial facilities. We design and install control systems to modernize your existing equipment with the latest technology to help reduce your facilities energy spend while also making it easier to support with proactive monitoring tools and reporting.
                            </p>
                            <router-link class="btn btn-primary " to="/facility-refrigeration-controls">Controls with ETC</router-link>
                        </div>
                    </div>
                </div>
                <div class="section-story-overview">
                    <div class="row">
                        <div class="col-md-6">
                            <!-- First image on the left side -->
                            <div class="image-container image-left ipad-left" style="box-shadow: none;">
                                    <!-- <img v-lazy="'img/ipadgamshaccp.png'" alt="Refrigeration Monitoring" class="" style="    max-width: 550px;"> -->
                                    <img v-lazy="'img/ipad4.png'" alt="Refrigeration Monitoring" class="" style="    max-width: 550px;">
                                <p class="blockquote blockquote-primary ipad-quote" style="border:none;">
                                    <!-- <span class="category text-primary" style="font-size: .9em;">Monitoring</span> -  -->
                                    <a href="https://gamsplus.com" target="_blank"><img v-lazy="'img/GLOGO512.png'" alt="GAMS+ Refrigeration Monitoring" class="" style="width: 50%;margin:0px auto 10px auto;display:block;position:relative;"></a>
                                    View and control your system remotely with our powerful <strong style="color:rgb(0, 255, 149);">G</strong>raphical
                                <strong style="color:rgb(0, 255, 149);">A</strong>larm
                                <strong style="color:rgb(0, 255, 149);">M</strong>onitoring
                                <!-- <strong style="color:#26C281;">S</strong>ystem.<br/> -->
                                <strong style="color:rgb(0, 255, 149);">S</strong>ystem.<br/>
                                <!-- 00BDE9
                                E72901
                                FAF60B
                                00ff95 -->
                                </p>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <!-- First image on the right side, above the article -->
                            <!-- <div class="image-container image-right" v-lazy:background-image="'img/47.jpg'"> -->
                            <div class="image-container image-right" v-lazy:background-image="'img/monitor-gif.gif'">
                            <!-- <div class="image-container image-right" v-lazy:background-image="'img/home-monitor.png'"> -->
                            </div>
                            <!-- <h6 class="category text-primary">E-Decor</h6> -->
                            <h4 class="card-title"> GAMS+ HVAC-R Monitoring</h4>
                            <!-- <h6 class="category text-success">Facility Controls</h6> -->
                            <!-- <p>
                                We design and install new control systems to modernize your existing hardware with the newest technology, with the ability to view and interrogate your system remotely. 
                            </p> -->
                            <p>
                                Join the other cold storage warehouses, retailers, laboratories and testing facilities around the globe that have trusted ETC to provide real-time alert notifications, refrigeration analytics and performance dashboards that significantly reduce product loss and maintenance costs. 
                            </p>
                            <a class="btn btn-primary " href="https://gamsplus.com" target="_blank">
                                <strong><em>
                                    <span style="font-family: 'Open Sans',sans-serif;">
                                        <strong style="">G</strong>
                                        <strong style="">A</strong>
                                        <strong style="">M</strong>
                                        <strong style="">S</strong>+
                                    </span>
                                </em></strong>&trade;
                                Monitoring
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END PROJECTS 3      *********      -->
        <!--     *********    TESTIMONIALS 2     *********      -->
        <!-- <div class="testimonials-2" style="padding-bottom: 0px;">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center">
                        <el-carousel height="500px" class="carousel-centered">
                            <el-carousel-item>
                                <card type="testimonial" plain>
                                    <img slot="avatar" class="img img-raised rounded" src="img/pgo.png"/>
                                    <h5 class="card-description">"We had the crew at ETC changed out some equipment about 6 weeks ago in Ono with the goal of reducing noise (which we did by 70%) and to become more energy efficient. After a full month on this new equipment, we have spent $900 less in electric which is a 36% savings. At this rate, we will recoup the $9k investment in about 10 months. Impressive. Thanks Steve and crew for making it more pleasant to be there every day, as well as saving us some money."
                                    </h5>
                                    <h3 class="card-title">Christina Lorrey</h3>
                                    <div class="card-footer">
                                        <h6 class="category text-primary">Pete &amp; Gerry's</h6>
                                    </div>
                                </card>
                            </el-carousel-item> -->
                            <!-- <el-carousel-item>
                                <card type="testimonial" plain>
                                    <img slot="avatar" class="img img-raised rounded" src="img/olivia.jpg"/>

                                    <h5 class="card-description">"When we are no longer able to change a
                                        situation - we are challenged to change ourselves. Spread love
                                        everywhere you go. Let no one ever come to you without leaving happier.
                                        Problems are not stop signs, they are guidelines."
                                    </h5>
                                    <h3 class="card-title">Alexa Hailey</h3>
                                    <div class="card-footer">
                                        <h6 class="category text-primary">Human Resource Director</h6>
                                    </div>
                                </card>

                            </el-carousel-item> -->

                        <!-- </el-carousel>
                    </div>
                </div>
            </div>
        </div> -->
        <!--     *********    END TESTIMONIALS 2      *********      -->
        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="latest != null && latest.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Latest Articles</h2>
                        <br />
                        <template  v-for="article in latest">
                        <card type="blog" plain :key="article._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="article.headerimg" @click="goTo(article._id)"  style="cursor:pointer;"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title title-top-big">
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                    </h3>
                                    <p class="card-description">
                                        {{article.readmore}}
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                    </p>
                                    <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div>
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>

<script>
import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
        Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Facility Controls, Monitoring & Engineering',
      meta: [
        { vmid: 'description', name: 'description', content: 'We’re a full-service commercial & industrial refrigeration, HVAC, and lighting controls engineering firm focused on providing energy efficiency and monitoring solutions.' },
        { vmid: 'keywords', name: 'keywords', content: 'refrigeration control company,etc, commercial refrigeration, industrial refrigeration,control company,electrical control systems, engineering, refrigeration monitoring, danfoss, emerson, cpc, danfoss monitoring, HVAC controls, controls, refrigeration controls, PT1000, energy, refrigeration efficiency, food safety, lighting control' }
      ],
      links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com'}
            ]
    },
    data () {
        return {
            windowWidth: null,
            latest: null,
            domain: 'https://api.website.gamsplus.systems',
        }
    },
    created() {
        this.windowWidth = window.innerWidth
        
    },
    mounted() {
        this.getLatest()
        particlesJS.load('particles-js', 'assets/particles.json', function() {
            console.log('callback - particles.js config loaded');
        });
    },
    methods: {
        // track () {
        //     // setTimeout(() => {
        //         this.$ga.page(this.$router)
        //     // }, 1000);
        // },
        getLatest() {
            this.$http.post(this.domain+'/articles/latest',{
                    'title': '',
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
            })
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
            // window.scrollTo(0,0);
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        },
        onStart(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    },
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
    .no-bg{
        background-color: transparent !important;
    }
    .btn{
        pointer-events:all;
    }
    @media (max-width: 768px){
        h1.title{
            font-size:5em;
        }
    }
    @media screen and (min-width: 991px){
        h1.title{
            font-size:7em;
        }
    }
    @media screen and (max-width: 576px){
        h1.title{
            font-size:3.5em;
        }
    }
    
</style>
<style>
.page-header.page-header-small {
    min-height: 500px;
    max-height: 500px;
}
.features-7 .info-horizontal {
    padding: 15px 0 0;
}
.info .info-title{
    margin: 23px 0 15px !important;
}
.font-color-primary{
    color: #ff5e00 !important;
}
a.font-color-primary:hover{
    border-color: transparent !important;
    text-decoration: underline !important;
}
    
    .bg-dark {
        background-color: #000000 !important;
    }
    .nolink:hover{
        text-decoration:none;
    }
</style>
<style scoped>
.ipad-quote{
    top: 400px !important;
}
@media screen and (min-width: 769px){
    .title-top-big{
        margin-top:0px;
    }
}
@media screen and (max-width: 991px){
    .ipad-quote{
        top: 375px !important;
    }
}
@media screen and (max-width: 768px){
    .image-container.image-left {
        margin-bottom: 350px;
    }
    
    
    .section-story-overview {
        padding: 50px 0 0 0;
    }
}
@media screen and (max-width: 450px){
.image-container.image-left.ipad-left {
        margin-bottom: 290px;
    }
    .ipad-quote{
        top: 300px !important;
    }
}
@media screen and (max-width: 420px){
    h1.title {
        font-size: 3em;
    }
    .image-container.image-left.ipad-left {
        margin-bottom: 230px;
    }
    .ipad-quote{
        top: 270px !important;
    }
}
@media screen and (max-width: 350px){
    h1.title {
        font-size: 2.5em;
    }
    .image-container.image-left.ipad-left {
        margin-bottom: 200px;
    }
    .ipad-quote{
        top: 225px !important;
    }
}
.carousel-centered {
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
